import axios from "axios"
import qs from "qs"
import { Message } from "element-ui";
import store from "../store";
import router from "../router/index.js"

// 请求超时时间
const service = axios.create({
	// timeout: 10000, //请求超時時间
})
// post请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 设置公共url
// axios.defaults.baseURL = 'http://127.0.0.1:7001'

// 添加请求拦截器
service.interceptors.request.use(
	config => {
		var loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
		config.headers = {
			'Content-Type': 'application/x-www-form-urlencoded',
			'sid':	loginInfo ? loginInfo.sid : '',
			'token': loginInfo ? loginInfo.token : '',
			'uid': loginInfo? loginInfo.admin_id : ''
		}
		return config;
	},
	error => {
		//请求错误处理
		return Promise.reject(error)
	}
)

// 添加响应拦截器
service.interceptors.response.use(
	response => {
		if (response.data.code == 1001) {
			Message.error(response.data.msg);
			setTimeout(()=> {
                let loginName = localStorage.getItem('system_login_name');
				sessionStorage.clear();
				localStorage.clear();
                if(loginName){
                    localStorage.setItem('system_login_name', loginName);
                }
				router.replace('/')
			}, 3000);
		}
		if(response.data.code == 1000){
			Message.error(response.data.msg);
		}
		return response.data;
	},
	error => {
		return Promise.reject(error);
	}
)

export default service